import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { callApi } from 'src/core/callApi';
import { timeZoneCCMap } from 'src/App/assets/timeZoneCCMap';
import { getMarketingTrackers } from 'src/utils/functions';
import { Box } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { RoutesMap } from 'src/utils/const';
import { completePostSignupNavigation } from '../Register/utils/postSignupRedirect';

const GoogleAuth = ({
  landing,
  device,
  googleAuthRegisterThunk,
  urlToRedirect,
  loading,
  error,
  errorReason,
}) => {
  const history = useHistory();

  const setMarketingTrackingURL =
    'https://4b5jgzfm05.execute-api.us-east-2.amazonaws.com/default/setMarketingTracking';

  const [lang, page, type, region] = getMarketingTrackers();

  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const signupCountryCode = timeZoneCCMap[userTimeZone];
  const tailoredRegion = window.localStorage.getItem('tailoredRegion');
  const affiliateKey = window.localStorage.getItem('affiliatedKey');

  const onGoogleLoginSuccess = async (response: any) => {
    // console.log('Google Login Success: ', response);
    const clientId = response.credential;

    if (!clientId) {
      console.log('Google Login Failed!');
      return;
    }

    const search_attempt_history = localStorage.getItem('investment-search-attempts');
    const noOfUserSearch = search_attempt_history ? parseInt(search_attempt_history) : 0;

    const googleAuthResult = await googleAuthRegisterThunk({
      clientId,
      lang,
      page,
      type,
      region,
      landing,
      device,
      signupCountryCode,
      tailoredRegion,
      affiliateKey,
      noOfUserSearch,
    });
    if (googleAuthResult && googleAuthResult.ok) {
      callApi(
        setMarketingTrackingURL,
        {
          queryParams: {
            user_signed_up: true,
          },
        },
        false
      );
      localStorage.removeItem('marketing-trackers');
      if (googleAuthResult.isNewGoogleSignup) {
        completePostSignupNavigation();
        return;
      }
      history.push(urlToRedirect ? urlToRedirect : RoutesMap.Home);
      window.location.reload();
    }

    console.log('After Signup Success!');

    return;
  };

  const onGoogleLoginFailure = () => {
    console.log('Google Login Failed!');
  };

  return (
    <Box sx={{ marginTop: '10px' }}>
      <GoogleLogin onSuccess={onGoogleLoginSuccess} onError={onGoogleLoginFailure} />
    </Box>
  );
};

export default GoogleAuth;
